import React from "react";
import Countries from "../../modules/countries";

const CountriesPage = () => {
  return <Countries />;
};

export default CountriesPage;
